import React from 'react';
import { Profile as ProfileType } from './types';
import { CreateRouter } from '../router';

export const Profile = React.memo(({ profile }: { profile: ProfileType }) => {
    return (
        <CreateRouter config={profile.menu} Component={profile.component} />
    );
});
